export class IntegrationConnectionDTO {
  integrationConnectionId: number;

  integrationConnectionTypeId: number;

  authData: string;

  //a credential or grant is stored; the grant itself never leaves the API
  hasAuthData: boolean;

  config: string;

  isAuthorized: boolean | undefined;

  lastVerified?: string;

  lastError?: string;

  created: string;

  modified?: string;

  integrationTypeIds: number[];

  constructor() {
    this.integrationConnectionId = 0;
    this.integrationConnectionTypeId = 0;
    this.authData = '';
    this.hasAuthData = false;
    this.config = '';
    this.isAuthorized = undefined;
    this.created = '';
    this.integrationTypeIds = [];
  }
}

//The consent page the popup opens (POST integrations/connections/{id}/grant/start).
export class IntegrationConnectionGrantStartDTO {
  url: string;

  constructor() {
    this.url = '';
  }
}

//What the API's callback page handed this window (POST integrations/connections/{id}/grant/complete).
export class IntegrationConnectionGrantCompleteDTO {
  code: string;

  state: string;

  constructor() {
    this.code = '';
    this.state = '';
  }
}
